import { useNavigate } from 'react-router-dom';
import StatusCard from 'src/components/StatusCard';

export default function NotFoundPage() {
  const nav = useNavigate();
  return (
    <StatusCard
      layout='page'
      variant="not-found"
      imageSrc={process.env.PUBLIC_URL + '/static/images/status/404.svg'}
      title="404 – Page Not Found"
      message=" Sorry, the page you are looking for does not exist. Please check the URL or return to the home page."
      actionLabel="Go Home"
      onAction={() => nav('/')}
    />
  );
}
